// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"d2def6e0","422":"e3ffa6d6","503":"e586feea","687":"7d04f6b2","767":"66cbe87e"}[chunkId] + ".chunk.js";
};